import { geocode } from '~/services/geocode';

export default {
    methods: {
        async getLatLon(address) {
            if (!address.address_1 || !address.postcode) {
                return [];
            }

            if (window.Cypress) {
                return [0, 0];
            }

            const { geometry } = await geocode(`${address.address_1},${address.address_2},${address.postcode}`.replace(',,', ','));

            if (!geometry) {
                return [];
            }

            return [geometry.location.lat, geometry.location.lng];
        },
    },
};
